import React from "react";

export const TagContext = React.createContext();